import { PeriscopeSfBaseRecord } from '.';

export type PeriscopeSfApexClass = PeriscopeSfBaseRecord;

export enum ApexSyntaxKind {
	None = 0,
	SyntaxKeyword = 1,
	SyntaxType = 2,
	SyntaxNumericLiteral = 3,
	SyntaxStringLiteral = 4,
	SyntaxSoqlLiteral = 5,
	SyntaxComments = 6
}

export enum LinkKind {
	SfdcEntity = 7,
	SfdcField = 8,
	SfdcApexClass = 9
}

type Text = string;
type LinkId = number;

export type ApexCodeSpan = [ Text, LinkKind, LinkId, ApexSyntaxKind ];

export type ApexCodeHighlights = {
	spans: ApexCodeSpan[]
};
